// #####################################################################
// #                       MAIN ANIMATION JS FILE                      #
// #####################################################################

// Funktion zum Erweitern von Buttons

// #####################################################
// #  FIRST CARD IS ALWAYS EXPANDED ON PAGE LOAD       #
// #  CLOSE ALL OTHER CARDS IF CLICKING ANOTHER CARD  #
// #####################################################
export function expandButtons() {
    const accordions = document.querySelectorAll(".accordion-header");
    const slidingFlags = document.querySelectorAll(".sliding-flag");

    // *** Stellt sicher, dass die erste Karte geöffnet ist ***
    if (accordions.length > 0) {
        const firstAccordion = accordions[0];
        const firstContent = firstAccordion.nextElementSibling;

        firstAccordion.classList.add('active-header'); // Markiert erste Karte als aktiv
        if (firstContent) {
            firstContent.classList.add("expanded"); // Öffnet erste Karte
        }
    }

    // Event Listener für Klick auf die Akkordeon-Elemente
    accordions.forEach((accordion) => {
        accordion.addEventListener("click", function () {
            const content = this.nextElementSibling;

            // Falls dieselbe Karte geklickt wurde, einfach umschalten
            if (content.classList.contains("expanded")) {
                content.classList.remove("expanded");
                this.classList.remove('active-header');
                return; // Verhindert das Schließen aller Karten
            }

            // Schließt alle anderen Karten
            accordions.forEach((otherAccordion) => {
                if (otherAccordion !== accordion) {
                    otherAccordion.classList.remove('active-header');
                    const otherContent = otherAccordion.nextElementSibling;
                    if (otherContent) {
                        otherContent.classList.remove("expanded");
                    }
                }
            });

            // Öffnet die geklickte Karte
            content.classList.add("expanded");
            this.classList.add('active-header');
        });
    });

    // Event Listener für Sliding Flags
    slidingFlags.forEach((flag) => {
        flag.addEventListener("click", function () {
            this.classList.toggle("active");
            const additionalInfo = this.querySelector(".additional-info");
            if (additionalInfo) {
                additionalInfo.classList.toggle("show");
            }
        });
    });

    const coloredBox = document.querySelector('.colored-box-component');
    const whiteBox = document.querySelector('.white-box-component');

    if (coloredBox) {
        coloredBox.querySelectorAll('.accordion-header').forEach(header => {
            header.style.setProperty('background-color', 'white', 'important');
        });
    }

    if (whiteBox) {
        whiteBox.querySelectorAll('.accordion-header').forEach(header => {
            header.style.setProperty('background-color', '#dae8ac', 'important');
        });
    }


}


export function flipIngrediantCards() {
    document.querySelectorAll(".flip-card").forEach((card) => {
        card.addEventListener("click", function () {
            this.classList.toggle("active");
            document.querySelectorAll(".flip-card").forEach((otherCard) => {
                if (otherCard !== this) {
                    otherCard.classList.remove("active");
                }
            });
        });
    });

    window.addEventListener("click", function (event) {
        if (!event.target.closest(".flip-card")) {
            document.querySelectorAll(".flip-card").forEach((card) => {
                card.classList.remove("active");
            });
        }
    });
}

// export function carousel(containerSelector) {
//     const container = document.querySelector(containerSelector);
//     if (!container) {
//         console.error(`Container "${containerSelector}" not found.`);
//         return;
//     }

//     const cards = container.querySelectorAll('.we-card');
//     const leftArrow = container.querySelector('.left');
//     const rightArrow = container.querySelector('.right');
//     let currentCardIndex = 0;
//     const totalCards = cards.length;

//     if (!cards.length || !leftArrow || !rightArrow) {
//         console.error("Carousel elements are missing or incomplete.");
//         return;
//     }

//     // Update carousel state
//     function updateCarousel() {
//         // Entferne alte Klassen
//         cards.forEach(card => {
//             card.classList.remove(
//                 'active',
//                 'prev-1',
//                 'next-1',
//                 'prev-2',
//                 'next-2',
//                 'prev-3',
//                 'next-3'
//             );
//             // Wenn du willst, dass nur die aktive Karte klickbar ist,
//             // könntest du hier z. B. pointerEvents manipulieren –
//             // aber NICHT onclick entfernen:
//             // card.style.pointerEvents = 'none';
//         });

//         // Markiere die aktuelle Karte
//         cards[currentCardIndex].classList.add('active');
//         // und nur wenn du möchtest, dass nur die aktive Karte klickbar ist:
//         // cards[currentCardIndex].style.pointerEvents = 'auto';

//         // Bestimme Nachbar-Indexe für prev-1 / next-1
//         const prevIndex_1 = (currentCardIndex - 1 + totalCards) % totalCards;
//         const nextIndex_1 = (currentCardIndex + 1) % totalCards;

//         cards[prevIndex_1].classList.add('prev-1');
//         cards[nextIndex_1].classList.add('next-1');
//     }

//     // Initial
//     updateCarousel();

//     // Eventlistener für Pfeile
//     rightArrow.addEventListener('click', function () {
//         currentCardIndex = (currentCardIndex + 1) % totalCards;
//         updateCarousel();
//     });

//     leftArrow.addEventListener('click', function () {
//         currentCardIndex = (currentCardIndex - 1 + totalCards) % totalCards;
//         updateCarousel();
//     });

//     // Swipe für Mobile
//     let startX = 0;
//     container.addEventListener('touchstart', (e) => {
//         startX = e.touches[0].clientX;
//     });

//     container.addEventListener('touchend', (e) => {
//         const endX = e.changedTouches[0].clientX;
//         if (startX > endX + 50) {
//             currentCardIndex = (currentCardIndex + 1) % totalCards;
//             updateCarousel();
//         } else if (startX < endX - 50) {
//             currentCardIndex = (currentCardIndex - 1 + totalCards) % totalCards;
//             updateCarousel();
//         }
//     });

//     // Responsiv
//     window.addEventListener('resize', () => {
//         if (window.innerWidth <= 768) {
//             // Nur eine Karte anzeigen etc. – falls gewünscht
//             cards.forEach(card => {
//                 card.style.transform = 'translateX(0)';
//             });
//         } else {
//             updateCarousel();
//         }
//     });
// }

export function carousel(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
        console.error(`Container "${containerSelector}" not found.`);
        return;
    }

    const cards = container.querySelectorAll('.we-card');
    const leftArrow = container.querySelector('.left');
    const rightArrow = container.querySelector('.right');
    let currentCardIndex = 0;
    const totalCards = cards.length;

    if (!cards.length || !leftArrow || !rightArrow) {
        console.error("Carousel elements are missing or incomplete.");
        return;
    }

    // -- NEU: Flag, um zu verhindern, dass die automatische Rotation mehrmals getriggert wird --
    let hasAutoScrolled = false;

    // Update carousel state
    function updateCarousel() {
        // Entferne alte Klassen
        cards.forEach(card => {
            card.classList.remove(
                'active',
                'prev-1',
                'next-1',
                'prev-2',
                'next-2',
                'prev-3',
                'next-3'
            );
        });

        // Markiere die aktuelle Karte
        cards[currentCardIndex].classList.add('active');

        // Bestimme Nachbar-Indexe für prev-1 / next-1
        const prevIndex_1 = (currentCardIndex - 1 + totalCards) % totalCards;
        const nextIndex_1 = (currentCardIndex + 1) % totalCards;

        cards[prevIndex_1].classList.add('prev-1');
        cards[nextIndex_1].classList.add('next-1');
    }

    // Initial
    updateCarousel();

    // Eventlistener für Pfeile
    rightArrow.addEventListener('click', function () {
        currentCardIndex = (currentCardIndex + 1) % totalCards;
        updateCarousel();
    });

    leftArrow.addEventListener('click', function () {
        currentCardIndex = (currentCardIndex - 1 + totalCards) % totalCards;
        updateCarousel();
    });

    // Swipe für Mobile
    let startX = 0;
    container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
    });

    container.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        if (startX > endX + 50) {
            currentCardIndex = (currentCardIndex + 1) % totalCards;
            updateCarousel();
        } else if (startX < endX - 50) {
            currentCardIndex = (currentCardIndex - 1 + totalCards) % totalCards;
            updateCarousel();
        }
    });

    // Responsiv
    window.addEventListener('resize', () => {
        if (window.innerWidth <= 768) {
            // Nur eine Karte anzeigen etc. – falls gewünscht
            cards.forEach(card => {
                card.style.transform = 'translateX(0)';
            });
        } else {
            updateCarousel();
        }
    });

    // -------------------------------------------
    // NEU: IntersectionObserver für einmaligen Auto-Scroll
    // -------------------------------------------
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            // Ist das Carousel im sichtbaren Bereich des Viewports?
            if (entry.isIntersecting && !hasAutoScrolled) {
                // Timer von 5 Sekunden starten
                setTimeout(() => {
                    currentCardIndex = (currentCardIndex + 1) % totalCards;
                    updateCarousel();
                }, 5000);

                // Verhindern, dass mehrmals automatisch gescrollt wird
                hasAutoScrolled = true;

                // Abhören beenden, um Performance zu schonen
                obs.unobserve(container);
            }
        });
    }, { threshold: 0.1 }); // threshold bestimmt, wieviel % sichtbar sein müssen (hier z.B. 10%)

    // Observer auf den Carousel-Container anwenden
    observer.observe(container);
}



export function verticalVideoSlider(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
        console.error(`Container "${containerSelector}" nicht gefunden.`);
        return;
    }

    const slides = container.querySelectorAll('.we-video');
    if (!slides.length) {
        console.error("Keine .we-video-Elemente im Container gefunden.");
        return;
    }

    let currentIndex = 0;
    const totalSlides = slides.length;
    const BLUR_DURATION = 300; // in Millisekunden (0.3s), passend zum CSS-Übergang

    /**
     * Entfernt alle Klassennamen, die für den Slider relevant sind.
     */
    function removeAllClasses(slide) {
        slide.classList.remove('active', 'vertical-prev-1', 'vertical-next-1', 'blur-out');
    }

    /**
     * Aktualisiert den Slider:
     * - Pausiert und resettet alle anderen Videos
     * - Setzt CSS-Klassen für active, prev, next
     * - Startet das aktive Video per .play()
     */
    function updateSlider() {
        slides.forEach((slide) => {
            removeAllClasses(slide);

            const vid = slide.querySelector('video');
            if (vid) {
                vid.pause();
                vid.currentTime = 0;
            }
        });

        // Active, prev, next
        slides[currentIndex].classList.add('active');
        const prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        const nextIndex = (currentIndex + 1) % totalSlides;
        slides[prevIndex].classList.add('vertical-prev-1');
        slides[nextIndex].classList.add('vertical-next-1');

        // Aktives Video starten
        const activeVideo = slides[currentIndex].querySelector('video');
        if (activeVideo) {
            activeVideo.play().catch(err => {
                console.warn('Autoplay blockiert oder Video konnte nicht starten:', err);
            });
        }
    }

    /**
     * Gehe zum nächsten Video.
     */
    function goToNext() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
    }

    /**
     * Gehe zum vorherigen Video.
     */
    function goToPrev() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlider();
    }

    /**
     * Initiales Setup:
     * - Erster Aufruf von updateSlider()
     * - Bei Video-Ende den Blur-Effekt aktivieren, dann nach kurzer Zeit goToNext()
     * - (Optional) Swipe für vertikales Wischen
     */
    function init() {
        updateSlider();

        // Wenn ein Video endet => Blur + kurzes Delay => Next
        slides.forEach((slide, index) => {
            const video = slide.querySelector('video');
            if (video) {
                video.addEventListener('ended', () => {
                    // Nur wenn dieses Video das aktuell laufende ist
                    if (index === currentIndex) {
                        // Blur-Effekt auf das aktive Slide
                        slide.classList.add('blur-out');

                        // Nach kurzer Zeit (passend zum CSS-Transition) zum nächsten Video wechseln
                        setTimeout(() => {
                            slide.classList.remove('blur-out');
                            goToNext();
                        }, BLUR_DURATION);
                    }
                });
            }
        });

        // Optional: Swipe-Unterstützung (Vertikal)
        let startY = 0;
        container.addEventListener('touchstart', (e) => {
            startY = e.touches[0].clientY;
        });
        container.addEventListener('touchend', (e) => {
            const endY = e.changedTouches[0].clientY;
            if (startY > endY + 50) {
                goToNext();
            } else if (startY < endY - 50) {
                goToPrev();
            }
        });
    }

    init();
}

export function slideFlags() {
    const icons = document.querySelectorAll(".icon-grid-1 img");

    icons.forEach(icon => {
        const popupCard = icon.nextElementSibling; // Popup direkt neben dem Icon im DOM
        const closeButton = popupCard.querySelector(".close-btn");

        // Klick auf das Icon öffnet das zugehörige Popup
        icon.addEventListener("click", function (event) {
            event.stopPropagation(); // Verhindert, dass das Dokument-Click-Event ausgelöst wird

            // Andere Popups schließen
            document.querySelectorAll(".popup-card.visible").forEach(popup => {
                popup.classList.remove("visible");
                popup.style.display = "none";
            });

            // Setze Position und zeige das Popup an
            const iconRect = icon.getBoundingClientRect();
            const popupWidth = popupCard.offsetWidth;
            const popupHeight = popupCard.offsetHeight;

            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            let leftPosition = iconRect.right + 10;
            let topPosition = iconRect.top + window.scrollY;

            if (leftPosition + popupWidth > viewportWidth) {
                leftPosition = iconRect.left - popupWidth - 10;
            }

            if (topPosition + popupHeight > viewportHeight + window.scrollY) {
                topPosition = viewportHeight + window.scrollY - popupHeight - 10;
            }

            leftPosition = Math.max(leftPosition, 10);
            topPosition = Math.max(topPosition, 10);

            // popupCard.style.top = `${topPosition}px`;
            // popupCard.style.left = `${leftPosition}px`;
            popupCard.style.display = "block";
            popupCard.classList.add("visible");
        });

        // Schließen des Popups bei Klick auf den Schließen-Button
        closeButton.addEventListener("click", function (event) {
            event.stopPropagation(); // Verhindert das Schließen durch das Dokument-Click-Event
            popupCard.classList.remove("visible");
            popupCard.style.display = "none";
        });
    });

    // Schließen aller Popups bei Klick außerhalb
    document.addEventListener("click", function () {
        document.querySelectorAll(".popup-card.visible").forEach(popup => {
            popup.classList.remove("visible");
            popup.style.display = "none";
        });
    });
}

export function carouselMagazin(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const cardContainer = container.querySelector('.mag-card-container');
    const cards = Array.from(cardContainer.children);
    const leftArrow = container.querySelector('.left');
    const rightArrow = container.querySelector('.right');
    const cardWidth = cards[0].offsetWidth + 15; // Include margin
    const visibleCards = 3; // Number of cards visible in the carousel
    let currentIndex = visibleCards;

    // Clone cards for infinite looping
    cards.forEach(card => {
        const cloneLeft = card.cloneNode(true);
        const cloneRight = card.cloneNode(true);
        cardContainer.appendChild(cloneRight);
        cardContainer.insertBefore(cloneLeft, cardContainer.firstChild);
    });

    const totalCards = cardContainer.children.length;

    // Initial setup
    let currentTranslate = -(currentIndex * cardWidth);
    cardContainer.style.transform = `translateX(${currentTranslate}px)`;

    // Function to update active state
    function updateActiveCard() {
        const allCards = Array.from(cardContainer.children);
        allCards.forEach((card, index) => {
            card.classList.remove('active');
            if (index === currentIndex + 1) {
                card.classList.add('active');
            }
        });
    }

    updateActiveCard();

    // Update carousel
    function updateCarousel(direction) {
        cardContainer.style.transition = 'transform 0.5s ease';
        if (direction === 'next') {
            currentIndex++;
            currentTranslate -= cardWidth;
        } else if (direction === 'prev') {
            currentIndex--;
            currentTranslate += cardWidth;
        }
        cardContainer.style.transform = `translateX(${currentTranslate}px)`;

        // Infinite loop handling
        setTimeout(() => {
            if (currentIndex >= totalCards - visibleCards) {
                currentIndex = visibleCards;
                currentTranslate = -(currentIndex * cardWidth);
                cardContainer.style.transition = 'none';
                cardContainer.style.transform = `translateX(${currentTranslate}px)`;
            } else if (currentIndex < visibleCards) {
                currentIndex = totalCards - visibleCards * 2;
                currentTranslate = -(currentIndex * cardWidth);
                cardContainer.style.transition = 'none';
                cardContainer.style.transform = `translateX(${currentTranslate}px)`;
            }
            updateActiveCard();
        }, 500);
    }

    // Arrow click events
    rightArrow.addEventListener('click', () => updateCarousel('next'));
    leftArrow.addEventListener('click', () => updateCarousel('prev'));

    // Touch support
    let startX = 0;
    cardContainer.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
    });

    cardContainer.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        if (startX > endX + 50) updateCarousel('next');
        else if (startX < endX - 50) updateCarousel('prev');
    });
}


export function hideCartButtonIfSanawissen() {
    // Prüfen, ob "sanawissen/" in der URL vorkommt
    if (window.location.href.indexOf("sanawissen/") !== -1) {
        // Alle Elemente mit der Klasse 'header-cart-btn-wrapper' auswählen
        const elements = document.querySelectorAll(".header-cart-btn-wrapper");
        // Und ausblenden
        elements.forEach(element => {
            element.style.display = "none";
        });
    }
}



/**
 * Initialisiert die Produkt‐Sidebar + Vorschau‐Box (Affiliate‐Media).
 *
 * @param {string} itemSelector   CSS‐Selector für alle <li>-Einträge (.am-product-item)
 * @param {string} previewSelector CSS‐Selector für die Preview‐Box (.am-preview)
 * @param {string} imgSelector    CSS‐Selector für das <img>-Tag in der Preview (#am-preview-img)
 * @param {number} fadeDuration   Dauer des Fade‐In/Out in ms
 */
export function initAffiliateMedia(
    itemSelector = '.affiliate-media .am-product-item',
    previewSelector = '.affiliate-media .am-preview',
    imgSelector = '#am-preview-img',
    fadeDuration = 200
) {
    // 1) Alle Sidebar‐Items und die Preview‐Box selektieren
    const items = document.querySelectorAll(itemSelector);
    const previewBox = document.querySelector(previewSelector);
    const previewImg = document.querySelector(imgSelector);
    // previewImg.style.display = "none";

    if (!items.length || !previewBox || !previewImg) {
        // Wenn irgendwas fehlt, beenden wir
        return;
    }

    items.forEach(item => {
        item.addEventListener('click', () => {
            // 1a) Active‐Klasse auf das geklickte <li> setzen, andere entfernen
            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');

            // 1b) Die Preview‐Box direkt NACH dem geklickten <li> einfügen
            const parentUl = item.parentNode;
            parentUl.insertBefore(previewBox, item.nextSibling);

            // 1c) Bild wechseln mit Fade‐Out/Fade‐In
            const newSrc = item.dataset.img;
            previewImg.style.display = "block";
            previewImg.style.transition = `opacity ${fadeDuration}ms ease`;
            previewImg.style.opacity = 0;

            setTimeout(() => {
                previewImg.src = newSrc;
                previewImg.onload = () => {
                    previewImg.style.opacity = 1;
                };
            }, fadeDuration);
        });
    });
}


/**
 * Initialisiert den Produkt‐Tab‐Wechsel (rechts: .am-post-section ein/ausblenden).
 *
 * @param {string} navSelector     CSS‐Selector für die Sidebar‐Items (.am-product-item)
 * @param {string} contentSelector CSS‐Selector für die Content‐Sektionen (.am-post-section)
 * @param {string} activeClass     CSS‐Klasse, die das aktive Sidebar‐Item markiert
 * @param {string} hiddenClass     CSS‐Klasse, die eine Sektion versteckt
 */
export function initProductTabs(
    navSelector,
    contentSelector,
    activeClass = 'active',
    hiddenClass = 'hidden'
) {
    const tabs = document.querySelectorAll(navSelector);
    const sections = document.querySelectorAll(contentSelector);

    if (!tabs.length || !sections.length) {
        // Wenn keine Tabs oder keine Sections gefunden werden, bleib stehen
        return;
    }

    function switchProduct(productKey) {
        // 1) Active‐Klasse in der Sidebar, abhängig vom data-product
        tabs.forEach(tab => {
            const isActive = tab.dataset.product === productKey;
            tab.classList.toggle(activeClass, isActive);
        });
        // 2) Content‐Bereich ein/ausblenden
        sections.forEach(sec => {
            const isMatch = sec.dataset.product === productKey;
            sec.classList.toggle(hiddenClass, !isMatch);
        });
    }

    // Klick‐Handler auf jedes <li>
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            switchProduct(tab.dataset.product);
        });
    });

    // Beim ersten Laden: die erste Sidebar‐Entry aktiv schalten
    if (tabs.length > 0) {
        switchProduct(tabs[0].dataset.product);
    }
}

